import { searchMaxWidth, searchMenu } from "./search";
import getCurrentYearCopyright from "./footer";
import initSmoothScrollLinks from "../common/initSmoothScrollLinks";

const searchInput = document.getElementById("searchinput");
const searchButton = document.getElementById("searchbtn");

function updateSearchState(searchInputValue, searchBtn) {
  const hasValue = searchInputValue.value.trim() !== "";
  searchBtn.classList.toggle("is-search", hasValue);
  searchBtn.classList.toggle("search-icon", !hasValue);
}

/**
 * Инициализирует функции после загрузки DOM.
 */
document.addEventListener("DOMContentLoaded", () => {
  getCurrentYearCopyright();
  initSmoothScrollLinks();
  searchMaxWidth();
  searchMenu(searchInput, searchButton);
  updateSearchState(searchInput, searchButton);
});
